import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PreviewLockImpactQueryVariables = Types.Exact<{
  lockType: Types.Scalars['String']['input'];
  sourceId: Types.Scalars['ID']['input'];
  schoolId: Types.Scalars['ID']['input'];
}>;


export type PreviewLockImpactQuery = { __typename?: 'RootQueryType', previewLockImpact: { __typename?: 'ImpactPreview', openAssignmentCount: number, closedAssignmentCount: number } };


export const PreviewLockImpactDocument = gql`
    query PreviewLockImpact($lockType: String!, $sourceId: ID!, $schoolId: ID!) {
  previewLockImpact(lockType: $lockType, sourceId: $sourceId, schoolId: $schoolId) {
    openAssignmentCount
    closedAssignmentCount
  }
}
    `;

/**
 * __usePreviewLockImpactQuery__
 *
 * To run a query within a React component, call `usePreviewLockImpactQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviewLockImpactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviewLockImpactQuery({
 *   variables: {
 *      lockType: // value for 'lockType'
 *      sourceId: // value for 'sourceId'
 *      schoolId: // value for 'schoolId'
 *   },
 * });
 */
export function usePreviewLockImpactQuery(baseOptions: Apollo.QueryHookOptions<PreviewLockImpactQuery, PreviewLockImpactQueryVariables> & ({ variables: PreviewLockImpactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviewLockImpactQuery, PreviewLockImpactQueryVariables>(PreviewLockImpactDocument, options);
      }
export function usePreviewLockImpactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviewLockImpactQuery, PreviewLockImpactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviewLockImpactQuery, PreviewLockImpactQueryVariables>(PreviewLockImpactDocument, options);
        }
// @ts-ignore
export function usePreviewLockImpactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PreviewLockImpactQuery, PreviewLockImpactQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewLockImpactQuery, PreviewLockImpactQueryVariables>;
export function usePreviewLockImpactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewLockImpactQuery, PreviewLockImpactQueryVariables>): Apollo.UseSuspenseQueryResult<PreviewLockImpactQuery | undefined, PreviewLockImpactQueryVariables>;
export function usePreviewLockImpactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PreviewLockImpactQuery, PreviewLockImpactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PreviewLockImpactQuery, PreviewLockImpactQueryVariables>(PreviewLockImpactDocument, options);
        }
export type PreviewLockImpactQueryHookResult = ReturnType<typeof usePreviewLockImpactQuery>;
export type PreviewLockImpactLazyQueryHookResult = ReturnType<typeof usePreviewLockImpactLazyQuery>;
export type PreviewLockImpactSuspenseQueryHookResult = ReturnType<typeof usePreviewLockImpactSuspenseQuery>;
export type PreviewLockImpactQueryResult = Apollo.QueryResult<PreviewLockImpactQuery, PreviewLockImpactQueryVariables>;